
/* !!! This is code generated by Prisma. Do not edit directly. !!!
/* eslint-disable */

Object.defineProperty(exports, "__esModule", { value: true });

const {
  Decimal,
  objectEnumValues,
  makeStrictEnum,
  Public,
  getRuntime,
  skip
} = require('./runtime/index-browser.js')


const Prisma = {}

exports.Prisma = Prisma
exports.$Enums = {}

/**
 * Prisma Client JS version: 6.12.0
 * Query Engine version: 8047c96bbd92db98a2abc7c9323ce77c02c89dbc
 */
Prisma.prismaVersion = {
  client: "6.12.0",
  engine: "8047c96bbd92db98a2abc7c9323ce77c02c89dbc"
}

Prisma.PrismaClientKnownRequestError = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`PrismaClientKnownRequestError is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)};
Prisma.PrismaClientUnknownRequestError = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`PrismaClientUnknownRequestError is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.PrismaClientRustPanicError = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`PrismaClientRustPanicError is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.PrismaClientInitializationError = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`PrismaClientInitializationError is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.PrismaClientValidationError = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`PrismaClientValidationError is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.Decimal = Decimal

/**
 * Re-export of sql-template-tag
 */
Prisma.sql = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`sqltag is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.empty = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`empty is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.join = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`join is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.raw = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`raw is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.validator = Public.validator

/**
* Extensions
*/
Prisma.getExtensionContext = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`Extensions.getExtensionContext is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.defineExtension = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`Extensions.defineExtension is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}

/**
 * Shorthand utilities for JSON filtering
 */
Prisma.DbNull = objectEnumValues.instances.DbNull
Prisma.JsonNull = objectEnumValues.instances.JsonNull
Prisma.AnyNull = objectEnumValues.instances.AnyNull

Prisma.NullTypes = {
  DbNull: objectEnumValues.classes.DbNull,
  JsonNull: objectEnumValues.classes.JsonNull,
  AnyNull: objectEnumValues.classes.AnyNull
}



/**
 * Enums
 */

exports.Prisma.TransactionIsolationLevel = makeStrictEnum({
  ReadUncommitted: 'ReadUncommitted',
  ReadCommitted: 'ReadCommitted',
  RepeatableRead: 'RepeatableRead',
  Serializable: 'Serializable'
});

exports.Prisma.UserScalarFieldEnum = {
  id: 'id',
  firstName: 'firstName',
  lastName: 'lastName',
  email: 'email',
  password: 'password',
  phone: 'phone',
  addressLine1: 'addressLine1',
  addressLine2: 'addressLine2',
  city: 'city',
  state: 'state',
  postalCode: 'postalCode',
  country: 'country',
  companyName: 'companyName',
  companyABN: 'companyABN',
  identityVerified: 'identityVerified',
  emailVerified: 'emailVerified',
  role: 'role',
  isActive: 'isActive',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.TokenScalarFieldEnum = {
  id: 'id',
  userId: 'userId',
  type: 'type',
  token: 'token',
  expiresAt: 'expiresAt',
  createdAt: 'createdAt'
};

exports.Prisma.EquipmentCategoryScalarFieldEnum = {
  id: 'id',
  name: 'name',
  slug: 'slug',
  parentId: 'parentId',
  sortOrder: 'sortOrder',
  isFeatured: 'isFeatured'
};

exports.Prisma.EquipmentScalarFieldEnum = {
  id: 'id',
  name: 'name',
  slug: 'slug',
  categoryId: 'categoryId',
  description: 'description',
  quantity: 'quantity',
  instantBooking: 'instantBooking',
  isAvailableForHire: 'isAvailableForHire',
  primaryImage: 'primaryImage',
  galleryImages: 'galleryImages',
  features: 'features',
  availabilityBlocked: 'availabilityBlocked',
  icalUrl: 'icalUrl',
  isFeatured: 'isFeatured',
  featuredOrder: 'featuredOrder',
  createdById: 'createdById',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  condition: 'condition',
  makeAndModel: 'makeAndModel',
  serialNumber: 'serialNumber',
  displayDailyPrice: 'displayDailyPrice',
  displayWeeklyPrice: 'displayWeeklyPrice',
  dailyPrice: 'dailyPrice',
  weeklyPrice: 'weeklyPrice',
  priceBandSchemeId: 'priceBandSchemeId'
};

exports.Prisma.EquipmentPricingScalarFieldEnum = {
  id: 'id',
  equipmentId: 'equipmentId',
  basePricePerDay: 'basePricePerDay',
  discountPercentage: 'discountPercentage',
  minimumDaysForDiscount: 'minimumDaysForDiscount',
  depositAmount: 'depositAmount',
  deliveryCharges: 'deliveryCharges',
  insuranceType: 'insuranceType',
  insuranceFee: 'insuranceFee',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.PricingTierScalarFieldEnum = {
  id: 'id',
  equipmentPricingId: 'equipmentPricingId',
  minDays: 'minDays',
  maxDays: 'maxDays',
  price: 'price',
  unit: 'unit'
};

exports.Prisma.BookingScalarFieldEnum = {
  id: 'id',
  equipmentId: 'equipmentId',
  adminConfirmed: 'adminConfirmed',
  basePricePerDay: 'basePricePerDay',
  bookingStatus: 'bookingStatus',
  companyInsuranceAccepted: 'companyInsuranceAccepted',
  createdAt: 'createdAt',
  daysBooked: 'daysBooked',
  deliveryAddress: 'deliveryAddress',
  deliveryFee: 'deliveryFee',
  deliveryRequired: 'deliveryRequired',
  depositAmount: 'depositAmount',
  discountPercentage: 'discountPercentage',
  endDate: 'endDate',
  equipmentCoverage: 'equipmentCoverage',
  finalTotal: 'finalTotal',
  hireAgreementAccepted: 'hireAgreementAccepted',
  hireAgreementSignedAt: 'hireAgreementSignedAt',
  hireAgreementVersion: 'hireAgreementVersion',
  insuranceFee: 'insuranceFee',
  insuranceType: 'insuranceType',
  notes: 'notes',
  paymentMethod: 'paymentMethod',
  paymentReference: 'paymentReference',
  paymentStatus: 'paymentStatus',
  pricingTierMaxDays: 'pricingTierMaxDays',
  pricingTierMinDays: 'pricingTierMinDays',
  pricingTierPrice: 'pricingTierPrice',
  pricingTierUnit: 'pricingTierUnit',
  publicLiability: 'publicLiability',
  quantity: 'quantity',
  startDate: 'startDate',
  taxAmount: 'taxAmount',
  taxPercentage: 'taxPercentage',
  thirdPartyCoverage: 'thirdPartyCoverage',
  totalRentalPrice: 'totalRentalPrice',
  updatedAt: 'updatedAt',
  userId: 'userId',
  userInsuranceCertUrl: 'userInsuranceCertUrl',
  userInsuranceComment: 'userInsuranceComment',
  userInsuranceCoverageAmount: 'userInsuranceCoverageAmount',
  userInsuranceExpiry: 'userInsuranceExpiry',
  userInsuranceExtraDocs: 'userInsuranceExtraDocs',
  userInsurancePolicyNumber: 'userInsurancePolicyNumber',
  userInsurancePolicySummaryUrl: 'userInsurancePolicySummaryUrl',
  userInsuranceProvider: 'userInsuranceProvider',
  userInsuranceStatus: 'userInsuranceStatus',
  userSignatureUrl: 'userSignatureUrl',
  userSignedAt: 'userSignedAt',
  workersCompensation: 'workersCompensation',
  photoIdUrl: 'photoIdUrl',
  proofOfAddressUrl: 'proofOfAddressUrl'
};

exports.Prisma.BookingOfferScalarFieldEnum = {
  id: 'id',
  token: 'token',
  customerEmail: 'customerEmail',
  customerName: 'customerName',
  customerPhone: 'customerPhone',
  equipmentId: 'equipmentId',
  startDate: 'startDate',
  endDate: 'endDate',
  quantity: 'quantity',
  offerPrice: 'offerPrice',
  depositAmount: 'depositAmount',
  deliveryFee: 'deliveryFee',
  notes: 'notes',
  status: 'status',
  expiresAt: 'expiresAt',
  createdById: 'createdById',
  simpleBookingId: 'simpleBookingId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  discountAmount: 'discountAmount',
  taxAmount: 'taxAmount',
  taxPercentage: 'taxPercentage'
};

exports.Prisma.SimpleBookingScalarFieldEnum = {
  id: 'id',
  bookingType: 'bookingType',
  customerEmail: 'customerEmail',
  customerName: 'customerName',
  customerPhone: 'customerPhone',
  customerAddress: 'customerAddress',
  equipmentId: 'equipmentId',
  startDate: 'startDate',
  endDate: 'endDate',
  quantity: 'quantity',
  photoIdUrl: 'photoIdUrl',
  proofOfAddressUrl: 'proofOfAddressUrl',
  totalAmount: 'totalAmount',
  depositAmount: 'depositAmount',
  deliveryFee: 'deliveryFee',
  paymentStatus: 'paymentStatus',
  paymentMethod: 'paymentMethod',
  paymentReference: 'paymentReference',
  stripePaymentIntentId: 'stripePaymentIntentId',
  status: 'status',
  adminNotes: 'adminNotes',
  userId: 'userId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.SettingScalarFieldEnum = {
  key: 'key',
  value: 'value',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.NewBookingScalarFieldEnum = {
  id: 'id',
  equipmentId: 'equipmentId',
  customerName: 'customerName',
  customerEmail: 'customerEmail',
  customerPhone: 'customerPhone',
  customerAddress: 'customerAddress',
  startDate: 'startDate',
  endDate: 'endDate',
  quantity: 'quantity',
  calculatedDays: 'calculatedDays',
  calculatedWeeks: 'calculatedWeeks',
  remainingDays: 'remainingDays',
  ratePerDay: 'ratePerDay',
  ratePerWeek: 'ratePerWeek',
  discountPercentage: 'discountPercentage',
  discountAmount: 'discountAmount',
  baseAmount: 'baseAmount',
  pickupFee: 'pickupFee',
  dropOffFee: 'dropOffFee',
  totalAmount: 'totalAmount',
  paymentStatus: 'paymentStatus',
  bookingStatus: 'bookingStatus',
  paymentMethod: 'paymentMethod',
  paymentReference: 'paymentReference',
  stripePaymentId: 'stripePaymentId',
  token: 'token',
  adminNotes: 'adminNotes',
  pickupAt: 'pickupAt',
  dropOffAt: 'dropOffAt',
  weekendOverride: 'weekendOverride',
  returnPhotos: 'returnPhotos',
  damagePhotos: 'damagePhotos',
  returnNotes: 'returnNotes',
  completedAt: 'completedAt',
  archived: 'archived',
  archivedAt: 'archivedAt',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.InventoryHoldScalarFieldEnum = {
  id: 'id',
  equipmentId: 'equipmentId',
  startDate: 'startDate',
  endDate: 'endDate',
  quantity: 'quantity',
  reason: 'reason',
  token: 'token',
  expiresAt: 'expiresAt',
  createdAt: 'createdAt',
  newBookingId: 'newBookingId'
};

exports.Prisma.EquipmentBlockScalarFieldEnum = {
  id: 'id',
  equipmentId: 'equipmentId',
  startDate: 'startDate',
  endDate: 'endDate',
  quantity: 'quantity',
  reason: 'reason',
  notes: 'notes',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.PriceBandSchemeScalarFieldEnum = {
  id: 'id',
  name: 'name',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.PriceBandScalarFieldEnum = {
  id: 'id',
  schemeId: 'schemeId',
  minDays: 'minDays',
  maxDays: 'maxDays',
  label: 'label',
  price: 'price',
  unit: 'unit'
};

exports.Prisma.PriceBandDiscountRuleScalarFieldEnum = {
  id: 'id',
  schemeId: 'schemeId',
  minDays: 'minDays',
  maxDays: 'maxDays',
  percentOff: 'percentOff',
  stackable: 'stackable',
  priority: 'priority',
  activeFrom: 'activeFrom',
  activeTo: 'activeTo',
  label: 'label'
};

exports.Prisma.SalesProductScalarFieldEnum = {
  id: 'id',
  title: 'title',
  slug: 'slug',
  description: 'description',
  salePrice: 'salePrice',
  displayPrice: 'displayPrice',
  stockQuantity: 'stockQuantity',
  stockStatus: 'stockStatus',
  reservedQuantity: 'reservedQuantity',
  lowStockThreshold: 'lowStockThreshold',
  version: 'version',
  specifications: 'specifications',
  termsConditions: 'termsConditions',
  warranty: 'warranty',
  condition: 'condition',
  makeAndModel: 'makeAndModel',
  serialNumber: 'serialNumber',
  features: 'features',
  weight: 'weight',
  dimensions: 'dimensions',
  paymentInstructions: 'paymentInstructions',
  acceptedPaymentMethods: 'acceptedPaymentMethods',
  financingAvailable: 'financingAvailable',
  financingTerms: 'financingTerms',
  financingProvider: 'financingProvider',
  primaryImage: 'primaryImage',
  galleryImages: 'galleryImages',
  videoUrl: 'videoUrl',
  brochureUrl: 'brochureUrl',
  metaTitle: 'metaTitle',
  metaDescription: 'metaDescription',
  isFeatured: 'isFeatured',
  featuredOrder: 'featuredOrder',
  displayOrder: 'displayOrder',
  categoryId: 'categoryId',
  isActive: 'isActive',
  isPublished: 'isPublished',
  publishedAt: 'publishedAt',
  isAvailable: 'isAvailable',
  unavailableReason: 'unavailableReason',
  internalNotes: 'internalNotes',
  viewCount: 'viewCount',
  enquiryCount: 'enquiryCount',
  soldCount: 'soldCount',
  createdByName: 'createdByName',
  createdByEmail: 'createdByEmail',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.SalesStockMovementScalarFieldEnum = {
  id: 'id',
  productId: 'productId',
  type: 'type',
  quantity: 'quantity',
  previousQty: 'previousQty',
  newQty: 'newQty',
  reference: 'reference',
  reason: 'reason',
  notes: 'notes',
  createdByName: 'createdByName',
  createdByEmail: 'createdByEmail',
  createdAt: 'createdAt'
};

exports.Prisma.SalesProductCategoryScalarFieldEnum = {
  id: 'id',
  name: 'name',
  slug: 'slug',
  description: 'description',
  parentId: 'parentId',
  sortOrder: 'sortOrder',
  isFeatured: 'isFeatured',
  isActive: 'isActive',
  image: 'image',
  icon: 'icon',
  metaTitle: 'metaTitle',
  metaDescription: 'metaDescription',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.SalesEnquiryScalarFieldEnum = {
  id: 'id',
  productId: 'productId',
  customerName: 'customerName',
  customerEmail: 'customerEmail',
  customerPhone: 'customerPhone',
  customerCompany: 'customerCompany',
  customerAddress: 'customerAddress',
  message: 'message',
  deliveryPreference: 'deliveryPreference',
  deliveryAddress: 'deliveryAddress',
  status: 'status',
  priority: 'priority',
  adminNotes: 'adminNotes',
  followedUpAt: 'followedUpAt',
  followedUpByName: 'followedUpByName',
  followedUpByEmail: 'followedUpByEmail',
  convertedToOfferId: 'convertedToOfferId',
  convertedAt: 'convertedAt',
  source: 'source',
  referrer: 'referrer',
  utmSource: 'utmSource',
  utmMedium: 'utmMedium',
  utmCampaign: 'utmCampaign',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.SalesOfferScalarFieldEnum = {
  id: 'id',
  offerNumber: 'offerNumber',
  customerName: 'customerName',
  customerEmail: 'customerEmail',
  customerPhone: 'customerPhone',
  customerCompany: 'customerCompany',
  deliveryType: 'deliveryType',
  deliveryAddress: 'deliveryAddress',
  pickupLocation: 'pickupLocation',
  subtotal: 'subtotal',
  deliveryCharge: 'deliveryCharge',
  freightCharge: 'freightCharge',
  discount: 'discount',
  discountReason: 'discountReason',
  taxAmount: 'taxAmount',
  taxPercentage: 'taxPercentage',
  total: 'total',
  depositAmount: 'depositAmount',
  depositPercentage: 'depositPercentage',
  paymentTerms: 'paymentTerms',
  notes: 'notes',
  termsConditions: 'termsConditions',
  offerValidityDays: 'offerValidityDays',
  termsAccepted: 'termsAccepted',
  termsAcceptedAt: 'termsAcceptedAt',
  termsAcceptedIp: 'termsAcceptedIp',
  expiresAt: 'expiresAt',
  status: 'status',
  sentAt: 'sentAt',
  viewedAt: 'viewedAt',
  lastViewedAt: 'lastViewedAt',
  viewCount: 'viewCount',
  acceptedAt: 'acceptedAt',
  paidAt: 'paidAt',
  declinedAt: 'declinedAt',
  declinedReason: 'declinedReason',
  expiredAt: 'expiredAt',
  cancelledAt: 'cancelledAt',
  cancelledReason: 'cancelledReason',
  stockReservedAt: 'stockReservedAt',
  stockReservedUntil: 'stockReservedUntil',
  stockReleased: 'stockReleased',
  token: 'token',
  internalNotes: 'internalNotes',
  createdByName: 'createdByName',
  createdByEmail: 'createdByEmail',
  sourceEnquiryId: 'sourceEnquiryId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.SalesOfferItemScalarFieldEnum = {
  id: 'id',
  offerId: 'offerId',
  productId: 'productId',
  quantity: 'quantity',
  unitPrice: 'unitPrice',
  lineTotal: 'lineTotal',
  productTitle: 'productTitle',
  productDescription: 'productDescription',
  productSpecs: 'productSpecs',
  productCondition: 'productCondition',
  productMakeModel: 'productMakeModel',
  productSerialNumber: 'productSerialNumber',
  productImage: 'productImage',
  itemNotes: 'itemNotes',
  itemDiscount: 'itemDiscount',
  createdAt: 'createdAt'
};

exports.Prisma.SalesPaymentScalarFieldEnum = {
  id: 'id',
  offerId: 'offerId',
  stripePaymentIntentId: 'stripePaymentIntentId',
  stripeChargeId: 'stripeChargeId',
  stripeCustomerId: 'stripeCustomerId',
  stripeSessionId: 'stripeSessionId',
  amount: 'amount',
  currency: 'currency',
  status: 'status',
  paymentType: 'paymentType',
  paymentSequence: 'paymentSequence',
  paymentDescription: 'paymentDescription',
  paymentMethod: 'paymentMethod',
  paymentMethodDetails: 'paymentMethodDetails',
  cardBrand: 'cardBrand',
  cardLast4: 'cardLast4',
  cardExpMonth: 'cardExpMonth',
  cardExpYear: 'cardExpYear',
  stripeCustomerName: 'stripeCustomerName',
  stripeCustomerEmail: 'stripeCustomerEmail',
  processingFee: 'processingFee',
  netAmount: 'netAmount',
  authorizedAt: 'authorizedAt',
  capturedAt: 'capturedAt',
  failedAt: 'failedAt',
  refundedAt: 'refundedAt',
  partiallyRefundedAt: 'partiallyRefundedAt',
  failureCode: 'failureCode',
  failureMessage: 'failureMessage',
  failureReason: 'failureReason',
  refundReason: 'refundReason',
  refundAmount: 'refundAmount',
  refundedAmount: 'refundedAmount',
  refundNotes: 'refundNotes',
  stripeReceiptUrl: 'stripeReceiptUrl',
  receiptNumber: 'receiptNumber',
  metadata: 'metadata',
  ipAddress: 'ipAddress',
  userAgent: 'userAgent',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.SalesInvoiceScalarFieldEnum = {
  id: 'id',
  invoiceNumber: 'invoiceNumber',
  offerId: 'offerId',
  type: 'type',
  subtotal: 'subtotal',
  deliveryCharge: 'deliveryCharge',
  freightCharge: 'freightCharge',
  discount: 'discount',
  taxAmount: 'taxAmount',
  taxPercentage: 'taxPercentage',
  total: 'total',
  depositAmount: 'depositAmount',
  balanceAmount: 'balanceAmount',
  customerName: 'customerName',
  customerEmail: 'customerEmail',
  customerPhone: 'customerPhone',
  customerCompany: 'customerCompany',
  deliveryAddress: 'deliveryAddress',
  paymentMethod: 'paymentMethod',
  paymentReference: 'paymentReference',
  status: 'status',
  issuedAt: 'issuedAt',
  paidAt: 'paidAt',
  sentAt: 'sentAt',
  dueAt: 'dueAt',
  pdfUrl: 'pdfUrl',
  pdfGeneratedAt: 'pdfGeneratedAt',
  pdfVersion: 'pdfVersion',
  notes: 'notes',
  internalNotes: 'internalNotes',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.SalesEmailLogScalarFieldEnum = {
  id: 'id',
  to: 'to',
  cc: 'cc',
  bcc: 'bcc',
  subject: 'subject',
  type: 'type',
  templateId: 'templateId',
  offerId: 'offerId',
  enquiryId: 'enquiryId',
  invoiceId: 'invoiceId',
  status: 'status',
  sentAt: 'sentAt',
  deliveredAt: 'deliveredAt',
  openedAt: 'openedAt',
  clickedAt: 'clickedAt',
  bouncedAt: 'bouncedAt',
  failedAt: 'failedAt',
  openCount: 'openCount',
  clickCount: 'clickCount',
  errorMessage: 'errorMessage',
  bounceReason: 'bounceReason',
  provider: 'provider',
  providerMessageId: 'providerMessageId',
  metadata: 'metadata',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.SalesActivityLogScalarFieldEnum = {
  id: 'id',
  adminEmail: 'adminEmail',
  adminName: 'adminName',
  action: 'action',
  entityType: 'entityType',
  entityId: 'entityId',
  description: 'description',
  changes: 'changes',
  metadata: 'metadata',
  ipAddress: 'ipAddress',
  userAgent: 'userAgent',
  createdAt: 'createdAt'
};

exports.Prisma.SortOrder = {
  asc: 'asc',
  desc: 'desc'
};

exports.Prisma.NullableJsonNullValueInput = {
  DbNull: Prisma.DbNull,
  JsonNull: Prisma.JsonNull
};

exports.Prisma.QueryMode = {
  default: 'default',
  insensitive: 'insensitive'
};

exports.Prisma.NullsOrder = {
  first: 'first',
  last: 'last'
};

exports.Prisma.JsonNullValueFilter = {
  DbNull: Prisma.DbNull,
  JsonNull: Prisma.JsonNull,
  AnyNull: Prisma.AnyNull
};
exports.Role = exports.$Enums.Role = {
  ADMIN: 'ADMIN',
  USER: 'USER'
};

exports.TokenType = exports.$Enums.TokenType = {
  VERIFY_EMAIL: 'VERIFY_EMAIL',
  RESET_PASSWORD: 'RESET_PASSWORD'
};

exports.InsuranceFeeType = exports.$Enums.InsuranceFeeType = {
  PER_DAY: 'PER_DAY',
  FIXED: 'FIXED'
};

exports.PricingUnit = exports.$Enums.PricingUnit = {
  PER_DAY: 'PER_DAY',
  PER_BOOKING: 'PER_BOOKING'
};

exports.BookingStatus = exports.$Enums.BookingStatus = {
  PENDING_CONFIRMATION: 'PENDING_CONFIRMATION',
  INSURANCE_PENDING: 'INSURANCE_PENDING',
  AGREEMENT_PENDING: 'AGREEMENT_PENDING',
  PAYMENT_PENDING: 'PAYMENT_PENDING',
  CONFIRMED: 'CONFIRMED',
  READY_FOR_DISPATCH: 'READY_FOR_DISPATCH',
  ON_HIRE: 'ON_HIRE',
  RETURNED_PENDING_INSPECTION: 'RETURNED_PENDING_INSPECTION',
  COMPLETED: 'COMPLETED',
  CANCELLED: 'CANCELLED'
};

exports.InsuranceType = exports.$Enums.InsuranceType = {
  OWN_INSURANCE: 'OWN_INSURANCE',
  COMPANY_INSURANCE: 'COMPANY_INSURANCE'
};

exports.PaymentStatus = exports.$Enums.PaymentStatus = {
  PENDING: 'PENDING',
  PAID: 'PAID',
  FAILED: 'FAILED',
  REFUNDED: 'REFUNDED'
};

exports.InsuranceValidationStatus = exports.$Enums.InsuranceValidationStatus = {
  PENDING: 'PENDING',
  APPROVED: 'APPROVED',
  REJECTED: 'REJECTED'
};

exports.OfferStatus = exports.$Enums.OfferStatus = {
  SENT: 'SENT',
  VIEWED: 'VIEWED',
  COMPLETED: 'COMPLETED',
  EXPIRED: 'EXPIRED',
  CANCELLED: 'CANCELLED'
};

exports.SimpleBookingType = exports.$Enums.SimpleBookingType = {
  DIRECT: 'DIRECT',
  FROM_OFFER: 'FROM_OFFER'
};

exports.SimpleBookingStatus = exports.$Enums.SimpleBookingStatus = {
  PENDING_PAYMENT: 'PENDING_PAYMENT',
  PAID: 'PAID',
  CONFIRMED: 'CONFIRMED',
  READY_FOR_DISPATCH: 'READY_FOR_DISPATCH',
  ON_HIRE: 'ON_HIRE',
  COMPLETED: 'COMPLETED',
  CANCELLED: 'CANCELLED'
};

exports.NewBookingStatus = exports.$Enums.NewBookingStatus = {
  PENDING_PAYMENT: 'PENDING_PAYMENT',
  PAID: 'PAID',
  CONFIRMED: 'CONFIRMED',
  ON_HIRE: 'ON_HIRE',
  RETURNED: 'RETURNED',
  COMPLETED: 'COMPLETED',
  CANCELLED: 'CANCELLED'
};

exports.HoldReason = exports.$Enums.HoldReason = {
  CHECKOUT: 'CHECKOUT',
  ADMIN: 'ADMIN'
};

exports.BlockReason = exports.$Enums.BlockReason = {
  MANUAL: 'MANUAL',
  MAINTENANCE: 'MAINTENANCE',
  OFFLINE: 'OFFLINE',
  ICS: 'ICS',
  EXTERNAL_BOOKING: 'EXTERNAL_BOOKING'
};

exports.SalesStockStatus = exports.$Enums.SalesStockStatus = {
  IN_STOCK: 'IN_STOCK',
  LOW_STOCK: 'LOW_STOCK',
  OUT_OF_STOCK: 'OUT_OF_STOCK',
  RESERVED: 'RESERVED',
  SOLD: 'SOLD',
  NOT_AVAILABLE: 'NOT_AVAILABLE',
  TEMPORARILY_UNAVAILABLE: 'TEMPORARILY_UNAVAILABLE'
};

exports.SalesStockMovementType = exports.$Enums.SalesStockMovementType = {
  INITIAL_STOCK: 'INITIAL_STOCK',
  RESTOCK: 'RESTOCK',
  SALE: 'SALE',
  RESERVATION: 'RESERVATION',
  RESERVATION_RELEASE: 'RESERVATION_RELEASE',
  MANUAL_ADJUSTMENT: 'MANUAL_ADJUSTMENT',
  DAMAGE: 'DAMAGE',
  RETURN: 'RETURN',
  CORRECTION: 'CORRECTION',
  TRANSFER: 'TRANSFER'
};

exports.SalesDeliveryType = exports.$Enums.SalesDeliveryType = {
  PICKUP: 'PICKUP',
  STANDARD_DELIVERY: 'STANDARD_DELIVERY',
  EXPRESS_DELIVERY: 'EXPRESS_DELIVERY',
  FREIGHT: 'FREIGHT',
  CUSTOMER_ARRANGED: 'CUSTOMER_ARRANGED'
};

exports.SalesEnquiryStatus = exports.$Enums.SalesEnquiryStatus = {
  PENDING: 'PENDING',
  CONTACTED: 'CONTACTED',
  OFFER_SENT: 'OFFER_SENT',
  CONVERTED: 'CONVERTED',
  DECLINED: 'DECLINED',
  SPAM: 'SPAM',
  ARCHIVED: 'ARCHIVED'
};

exports.SalesEnquiryPriority = exports.$Enums.SalesEnquiryPriority = {
  LOW: 'LOW',
  NORMAL: 'NORMAL',
  HIGH: 'HIGH',
  URGENT: 'URGENT'
};

exports.SalesOfferStatus = exports.$Enums.SalesOfferStatus = {
  DRAFT: 'DRAFT',
  SENT: 'SENT',
  VIEWED: 'VIEWED',
  ACCEPTED: 'ACCEPTED',
  DEPOSIT_PAID: 'DEPOSIT_PAID',
  PAID: 'PAID',
  DECLINED: 'DECLINED',
  EXPIRED: 'EXPIRED',
  CANCELLED: 'CANCELLED'
};

exports.SalesPaymentStatus = exports.$Enums.SalesPaymentStatus = {
  PENDING: 'PENDING',
  PROCESSING: 'PROCESSING',
  AUTHORIZED: 'AUTHORIZED',
  SUCCEEDED: 'SUCCEEDED',
  FAILED: 'FAILED',
  CANCELLED: 'CANCELLED',
  REFUNDED: 'REFUNDED',
  PARTIALLY_REFUNDED: 'PARTIALLY_REFUNDED'
};

exports.SalesPaymentType = exports.$Enums.SalesPaymentType = {
  FULL: 'FULL',
  DEPOSIT: 'DEPOSIT',
  FINAL: 'FINAL',
  PARTIAL: 'PARTIAL'
};

exports.SalesInvoiceType = exports.$Enums.SalesInvoiceType = {
  FULL_PAYMENT: 'FULL_PAYMENT',
  DEPOSIT: 'DEPOSIT',
  BALANCE: 'BALANCE',
  PROFORMA: 'PROFORMA'
};

exports.SalesInvoiceStatus = exports.$Enums.SalesInvoiceStatus = {
  DRAFT: 'DRAFT',
  PENDING: 'PENDING',
  SENT: 'SENT',
  PAID: 'PAID',
  OVERDUE: 'OVERDUE',
  CANCELLED: 'CANCELLED',
  REFUNDED: 'REFUNDED'
};

exports.SalesEmailType = exports.$Enums.SalesEmailType = {
  ENQUIRY_RECEIVED: 'ENQUIRY_RECEIVED',
  ENQUIRY_CONFIRMATION: 'ENQUIRY_CONFIRMATION',
  OFFER_SENT: 'OFFER_SENT',
  OFFER_VIEWED: 'OFFER_VIEWED',
  OFFER_REMINDER: 'OFFER_REMINDER',
  OFFER_EXPIRING_SOON: 'OFFER_EXPIRING_SOON',
  PAYMENT_PENDING: 'PAYMENT_PENDING',
  PAYMENT_CONFIRMATION: 'PAYMENT_CONFIRMATION',
  PAYMENT_FAILED: 'PAYMENT_FAILED',
  INVOICE: 'INVOICE',
  RECEIPT: 'RECEIPT',
  LOW_STOCK_ALERT: 'LOW_STOCK_ALERT',
  OUT_OF_STOCK_ALERT: 'OUT_OF_STOCK_ALERT',
  RESTOCK_NOTIFICATION: 'RESTOCK_NOTIFICATION',
  ADMIN_NOTIFICATION: 'ADMIN_NOTIFICATION'
};

exports.SalesEmailStatus = exports.$Enums.SalesEmailStatus = {
  PENDING: 'PENDING',
  QUEUED: 'QUEUED',
  SENT: 'SENT',
  DELIVERED: 'DELIVERED',
  OPENED: 'OPENED',
  CLICKED: 'CLICKED',
  FAILED: 'FAILED',
  BOUNCED: 'BOUNCED',
  REJECTED: 'REJECTED',
  COMPLAINED: 'COMPLAINED'
};

exports.Prisma.ModelName = {
  User: 'User',
  Token: 'Token',
  EquipmentCategory: 'EquipmentCategory',
  Equipment: 'Equipment',
  EquipmentPricing: 'EquipmentPricing',
  PricingTier: 'PricingTier',
  Booking: 'Booking',
  BookingOffer: 'BookingOffer',
  SimpleBooking: 'SimpleBooking',
  Setting: 'Setting',
  NewBooking: 'NewBooking',
  InventoryHold: 'InventoryHold',
  EquipmentBlock: 'EquipmentBlock',
  PriceBandScheme: 'PriceBandScheme',
  PriceBand: 'PriceBand',
  PriceBandDiscountRule: 'PriceBandDiscountRule',
  SalesProduct: 'SalesProduct',
  SalesStockMovement: 'SalesStockMovement',
  SalesProductCategory: 'SalesProductCategory',
  SalesEnquiry: 'SalesEnquiry',
  SalesOffer: 'SalesOffer',
  SalesOfferItem: 'SalesOfferItem',
  SalesPayment: 'SalesPayment',
  SalesInvoice: 'SalesInvoice',
  SalesEmailLog: 'SalesEmailLog',
  SalesActivityLog: 'SalesActivityLog'
};

/**
 * This is a stub Prisma Client that will error at runtime if called.
 */
class PrismaClient {
  constructor() {
    return new Proxy(this, {
      get(target, prop) {
        let message
        const runtime = getRuntime()
        if (runtime.isEdge) {
          message = `PrismaClient is not configured to run in ${runtime.prettyName}. In order to run Prisma Client on edge runtime, either:
- Use Prisma Accelerate: https://pris.ly/d/accelerate
- Use Driver Adapters: https://pris.ly/d/driver-adapters
`;
        } else {
          message = 'PrismaClient is unable to run in this browser environment, or has been bundled for the browser (running in `' + runtime.prettyName + '`).'
        }

        message += `
If this is unexpected, please open an issue: https://pris.ly/prisma-prisma-bug-report`

        throw new Error(message)
      }
    })
  }
}

exports.PrismaClient = PrismaClient

Object.assign(exports, Prisma)
